import { Controller } from 'stimulus'

// The takeover consequence, the incumbent's matricule and the confirmation only apply to the modes
// that claim the SIREN's own line. The server enforces the same rule; this stops the form from
// warning about a change the customer has not chosen, and from offering to save the mode they are
// already on.
export default class extends Controller {
  static targets = [
    'consequence', 'matricule', 'submit',
    'address', 'addressSummary', 'standardAddress', 'dedicatedAddress', 'dedicatedHint', 'suffix'
  ]

  connect() {
    this.addressTouched = false
    this.initialDedicated = this.data.get('dedicated') === 'true'
    this.update()
  }

  update() {
    const mode = this.selectedMode

    if (this.hasConsequenceTarget) {
      this.toggle(this.consequenceTarget, this.receivingModes.includes(mode))
    }
    if (this.hasMatriculeTarget) {
      this.toggle(this.matriculeTarget, mode === this.data.get('transfer'))
    }
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = mode === null || mode === this.data.get('current')
    }

    this.updateAddress(mode)
  }

  updateAddress(mode) {
    if (!this.hasAddressTarget) return

    const transfer = mode === this.data.get('transfer')
    const sendOnly = mode === this.data.get('sendOnly')

    this.toggle(this.addressTarget, !transfer)
    if (this.hasStandardAddressTarget) this.toggle(this.standardAddressTarget, !sendOnly)

    // Send-only receives nothing, so the dedicated address is never one to give to suppliers.
    if (this.hasDedicatedHintTarget) {
      const hint = this.dedicatedHintTarget
      hint.textContent = sendOnly ? hint.dataset.sendOnly : hint.dataset.receiving
    }

    // Drop the untouched branch and passing through send-only leaves a receiving account on a
    // dedicated address it never asked for.
    if (transfer) this.check('0')
    else if (sendOnly) this.check('1')
    else if (!this.addressTouched) this.check(this.initialDedicated ? '1' : '0')

    this.updateSummary()
  }

  chooseDedicated() {
    this.selectAddress()
    this.check('1')
  }

  selectAddress() {
    this.addressTouched = true
    this.updateSummary()
  }

  updateSummary() {
    if (!this.hasAddressSummaryTarget) return

    const summary = this.addressSummaryTarget

    if (!this.dedicatedChosen) {
      summary.textContent = summary.dataset.standard
      return
    }

    summary.textContent = summary.dataset.dedicated.replace('%{suffix}', this.suffix)
  }

  get suffix() {
    if (!this.hasSuffixTarget) return ''

    return this.suffixTarget.value.trim().toUpperCase() || this.suffixTarget.placeholder
  }

  get dedicatedChosen() {
    const checked = this.addressRadio(':checked')
    return checked ? checked.value === '1' : false
  }

  get selectedMode() {
    const checked = this.element.querySelector('input[name="registration_mode"]:checked')
    return checked ? checked.value : null
  }

  get receivingModes() {
    return (this.data.get('receiving') || '').split(',')
  }

  check(value) {
    const radio = this.addressRadio(`[value="${value}"]`)
    if (radio) radio.checked = true
  }

  addressRadio(selector) {
    return this.element.querySelector(`input[name="dedicated_address"]${selector}`)
  }

  toggle(element, visible) {
    element.style.display = visible ? '' : 'none'
  }
}
